<template>
  <div class="footer pr ptb-100">
    <div class="footer-container df jc-sb">
      <div class="left">
        <p class="fw-b">深如美设（上海）供应链科技有限公司</p>
        <div class="mt-25">
          <span style="display: block">©2023 版权所有 All Rights Reserved</span>
          <p class="df">
            <span>
              <img
                src="../assets/img/contact/bata.png"
                alt=""
                width="16"
              />沪公网安备
              <a
                href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502008894"
                target="_blank"
                >31011502008894</a
              >号
            </span>
            <span>
              ICP备案编号：沪ICP备
              <a
                href="https://beian.miit.gov.cn/#/Integrated/index"
                target="_blank"
                class="color-black"
              >
              14043075号-37</a
              >
            </span>
          </p>
        </div>
      </div>
      <div class="right">
        <p>需要帮助?</p>
        <el-button class="mt-20">
          <router-link
            class="nav-link custom-nav-link color-white"
            :to="{ name: 'Contact' }"
          >
           联系我们
          </router-link></el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
};
</script>
